import { defineStore } from "pinia";
import {services, getHeader} from '@/assets/js/config.js'
import axios from "axios";
import { useAuthStore } from '@/stores/authStore'

export const useHestiaStore = defineStore('hestiaStore',{
    state:() => ({}),
    getters:{},
    actions: {
        async getHestiaCaseDetails(prod_pm_unit_id){
            try{
                const res = await axios.get(services.hestia + 'unit-im2u-resource/'+prod_pm_unit_id, {headers: getHeader()})
                return res.data.data
            }catch(e){
                console.log(e)
				_gNotif.errorFunction(e)
            }
        },
        async getChangeUnitList(prod_pm_unit_id){
            try{
                const res = await axios.get(services.hestia + 'projects-for-im2u/'+prod_pm_unit_id, {headers: getHeader()})
                return res.data.data

            }catch(e){
                console.log(e)
				_gNotif.errorFunction(e)
            }
        },
        async getHestiaProjectCoverImage(prod_pm_property_id) {
            try{
                const res = await axios.get(services.hestia + 'project/get-project-cover-image/'+prod_pm_property_id, {headers: getHeader()})
                return res.data.data
            }catch(e){
				_gNotif.errorFunction(e)
            }
        },
        async getHestiaLawyerTracking(prod_id) {
            try{
                const res = await axios.get(services.hestia + 'product-submission/show-by-product-id/'+prod_id, {headers: getHeader()})
                return res.data.data
            }catch(e){
                console.log('errr',e)
				_gNotif.errorFunction(e)
            }
        },
        async getHestiaProjectCommission(project_id) {
            try{
                const res = await axios.get(services.hestia + 'project-commission/show-by-project-id/'+project_id, {headers: getHeader()})
                return res.data
            }catch(e){
                console.log('errr',e)
				_gNotif.errorFunction(e)
            }
        },
        async getHestiaProjectBanks(project_id){
            try{
                const res = await axios.get(services.hestia + 'project-bank/by-project/'+project_id, {headers: getHeader()})
                return res.data.data
            }catch(e){
                console.log('errr',e)
				_gNotif.errorFunction(e)
            }
        },
        async updateHestiaUnitStatus(unit_id, status = 'RESERVED'){
            try{
                const data = {
                    status: status
                }
                const res = await axios.put(services.hestia + 'unit/'+unit_id, data, {headers: getHeader()})
                return res.data.data
            }catch(e){
                console.log('errr',e)
				_gNotif.errorFunction(e)
                throw e
            }
        }
    }
})